import { render } from "./createPublicPersonStepConjuge.vue?vue&type=template&id=1d469afc&scoped=true"
import script from "./createPublicPersonStepConjuge.vue?vue&type=script&lang=js"
export * from "./createPublicPersonStepConjuge.vue?vue&type=script&lang=js"

import "./createPublicPersonStepConjuge.vue?vue&type=style&index=0&id=1d469afc&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1d469afc"]])

export default __exports__